<!-- src/components/RadioGroup.vue -->
<template>
  <div class="pm-radio-group">
    <label v-for="option in options" :key="option.value" role="button" tabindex="0">
      <input
        type="radio"
        :name="name"
        :value="option.value"
        :checked="modelValue === option.value"
        @change="$emit('update:modelValue', option.value)"
      />
      <span>{{ option.label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'RadioGroup',
  props: {
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: [String, Number],
      required: true
    }
  },
  emits: ['update:modelValue'],
  methods: {
    change(){
      this.$emit('update:modelValue', this.modelValue)
    }
  }
}
</script>

<style scoped>
.pm-radio-group {
  display: flex;
  flex-flow: row wrap;
  border-radius: 24px 0 24px 24px;
  height: 45px;
  background-color: #E9E9EB;
  overflow: hidden;
}

.pm-radio-group label {
  font-size: 1.125rem;
  cursor: pointer;
  user-select: none;
}

.pm-radio-group input[type="radio"] {
  display: none;
}

.pm-radio-group span {
  padding: 15px 28px;
  color: var(--btn-text-invert);
  border-radius: 24px 0 24px 24px;
  display: block;
}

.pm-radio-group input[type="radio"]:checked + span {
  background-color: var(--red);
  color: var(--btn-text);
}

.pm-radio-group input[disabled] + span {
  filter: blur(1px);
  opacity: 0.6;
  cursor: not-allowed;
}
</style>